<template>
  <!--热卖榜单页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    hide-status-bar
    @refresh="refreshInit"
    @scroll="watchScroll"
    class="brand-special-bg"
    :style="{background: bgColor, backgroundImage: `url(${bgSrc}) !important`}"
    ref="resetHotList"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="!isHeaderColor" :icon-name="'return'">
      <div slot="center-menu" :style="{color: isHeaderColor ? '#000000' : '#fff'}">热卖榜单</div>
    </gradient-header>
    <!--背景图渲染-->
    <div style="padding-top: 70px;">
      <tk-flex center>
          <tk-image :src="'https://s3.moke.cloud/dianpei/0f171678-0312-47f3-b5ae-fb3390f77e60.png'" width="166" height="48"></tk-image>
      </tk-flex>
      <!--装饰图渲染-->
      <div class="p-x-12 m-t-24" @click="linkPage">
        <div class="hot-list-decoration" :style="`background-image: url(${decorationSrc}) !important`"></div>
      </div>
      <!--热榜排行渲染-->
      <div class="m-t-8">
        <div class="m-x-12" v-if="hotList.length">
          <card
            :height="100"
            :width="100"
            class="m-t-8 p-y-8 p-x-12"
            v-for="(s, index) in hotList"
            :key="index"
          >
            <lookCommodity
              :commodity="s"
              :list-index="index"
              :is-show-selling="false"
              :is-border="false"
              :bg-color="'#E2C492'"
              :selling-bg="'rgba(255, 255, 255, 0)'"
            >
              <div class="class-card-sales m-t-4" slot="sales">累计热销 {{s.sales ? s.sales : 0}}件</div>
            </lookCommodity>
          </card>
        </div>
        <div class="m-x-12" v-else>
          <card :height="100" class="m-t-8">
            <empty-tips :height="100" :width="100" :empty-msg="'暂无热卖数据'"></empty-tips>
          </card>
        </div>
      </div>
    </div>
    <!--为你推荐数据-->
    <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
  </tk-container>
</template>

<script>
import lookCommodity from '@/components/lookCommodity'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    lookCommodity
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      themeBackground: null, // 主题背景图片
      timeRule: {}, // 限时抢购时间规则
      hotList: [], // 热卖榜单数据
      recommendedProductsData: [] // 为你推荐商品数据获取
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.image)) { return '' }
      return this.themeBackground.image
    },
    // 背景颜色
    bgColor () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.bgColor)) { return '' }
      return this.themeBackground.bgColor
    },
    // 装饰图src
    decorationSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.decoration)) { return '' }
      return this.themeBackground.decoration
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/8
     */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getHotList() // 获取热卖榜单数据 （按销量倒序，只获取10条）
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetHotList.resetInfiniteScroll()
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 获取主题图片
     * @date: 2020/4/8
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          include: 'link',
          where: {
            position: 'hotList'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
     * 热卖榜单数据获取
     * @date: 2020/3/20
     */
    async getHotList () {
      let hotList = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 50,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      if (hotList.length) {
        this.hotList = priceProcessing(hotList.map((s, index) => {
          if (index === 0) { s.tipsImage = 'https://s3.moke.cloud/dianpei/31a6877c-c391-4cb2-a99d-3c9d66e2a901.png' }
          if (index === 1) { s.tipsImage = 'https://s3.moke.cloud/dianpei/4b0dbc5a-f6b7-4f8a-a11c-a29b32513262.png' }
          if (index === 2) { s.tipsImage = 'https://s3.moke.cloud/dianpei/b3001f37-f9db-4146-80e5-3810081f8936.png' }
          return s
        }), this.judgeTimeRule)
      } else {
        this.hotList = []
      }
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * link到商品详情
     * @date: 2020/4/27
     */
    async linkPage () {
      if (!this.themeBackground.link) { return }
      this.$push({ path: '/commodity/productDetails', query: { id: this.themeBackground.link.objectId } })
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
  .brand-special-bg {
    width: 100%;
    min-height: 425px;
    background-repeat: no-repeat !important;
    background-size: 100% 425px !important;
    background-attachment: fixed !important;
    .brand-special-color {
      color: #fff;
    }
  }
  /*装饰图片样式*/
  .hot-list-decoration {
    width: 100%;
    height: 145px;
    background-repeat:  no-repeat;
    background-size: 100% 100%;
  }
  /*销量样式*/
  .class-card-sales {
    font-size: 12px;
    color: rgba(207, 164, 65, 1);
  }
</style>
